import { C } from '../../tokens/design';

export default function Skeleton({ width = '100%', height = 14, style = {} }) {
  return (
    <div style={{
      width, height, borderRadius: 4,
      background: `linear-gradient(90deg, ${C.s2} 20%, ${C.b1} 48%, ${C.s2} 76%)`,
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.4s infinite linear',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.02)',
      ...style,
    }} />
  );
}
